export const en = {
  'not-found-description': 'Page not found',
}
